import React from 'react';
import { SectionPlaceholder } from '../../Placeholders/SectionPlaceholder';
import { ItemCardPlaceholder } from '../../Placeholders/ItemCardPlaceholder';
import useScreenSize from '../../../hooks/useScreenSize';

const DESK_PASHA_CARDS_IN_ROW = 5;
const DESK_PASHA_CARD_ROWS = 2;
const MOB_PASHA_CARD_ROWS = 3;

export const CardPlaceholder: React.FC = () => {
  const { isLarge, isSmall } = useScreenSize();

  return (
    <SectionPlaceholder
      rowCount={isSmall ? MOB_PASHA_CARD_ROWS : DESK_PASHA_CARD_ROWS}
      deskRowCount={DESK_PASHA_CARDS_IN_ROW}
      height={628}
    >
      {Array.from(
        { length: isLarge ? DESK_PASHA_CARDS_IN_ROW : MOB_PASHA_CARD_ROWS },
        (_, index) => (
          <ItemCardPlaceholder key={index} isCardsLayout />
        )
      )}
    </SectionPlaceholder>
  );
};
